import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AppSettings } from 'src/app/enums/app-settings.enum';
import { otpValidation } from 'src/app/models/otpValidation.model';
import { AccountService } from 'src/app/services/account.service';
import { AddonSubscriptionService } from 'src/app/services/addon-subscription.service';
import { AdobeAnalyticsService } from 'src/app/services/adobe-analytics.service';
import { ApplicationInitializationService } from 'src/app/services/application-initialization.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { ProductService } from 'src/app/services/product.service';
import { SessionDataService } from 'src/app/services/session-data.service';
import { SkuDataService } from 'src/app/services/sku-data.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { BogoOfferPopupComponent } from '../bogo-offer-popup/bogo-offer-popup.component';
import { AccountSelectionModalComponent } from '../account-selection-modal/account-selection-modal.component';
import { ParentalUtilsService } from 'src/app/services/parental-utils.service';

import { Router } from '@angular/router';
@Component({
  selector: 'app-otpverification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.scss'],
})
export class VerificationComponent implements OnInit {
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  @Input('data') data: any;
  otp: string = '';
  planName = '';
  roaming = false;
  otpVerificationScreen: boolean = false;
  otpValidationModel: otpValidation = new otpValidation();
  mobileNumber: any = '';
  maskedAccountNo: string = '';
  token: string;
  config = {
    allowNumbersOnly: true,
    length: 6,
    // isPasswordInput: true,
    disableAutoFocus: true,
    placeholder: '●',
    inputStyles: {
      width: '36px',
      height: '36px',
    },
  };
  showSubscriptionTemplate: boolean = false;
  showSuccessTemplate: boolean = false;
  sku: any;
  additionalBenefits: any;
  howtoSubscribe: any;
  termsCondition: any;
  main: any;
  addon: string = '';
  hiddenHeader: boolean;
  categoryDetail: any;
  categoryName: string;
  isArabic: boolean;
  showOTPError = true;
  OTPErrorMSG: any;
  enableResendcode: boolean = false;
  mobileErrorMSG: any;
  showMobileErrorMSG = false;
  showErrorTemplate: boolean;
  ismobileScreen: boolean;
  VerificationTemplate = false;
  loadingCompleted = false;
  language: string;
  userData: any;
  userLoggedIn: boolean;
  isATB: boolean = false;
  ATBPostpaidAccount: string;
  addonType: any;
  kidsAddon: boolean;
  showArenaProTemplate: boolean = false;
  numberlogin;
  bogoAddonsSubsribe = false;
  isParentalTarrifCardFlow: boolean = false;
  userAccounts: any[] = [];
  constructor(
    private modalController: ModalController,
    private productService: ProductService,
    private SKUDS: SkuDataService,
    private UTS: UtilitiesService,
    private SS: SubjectService,
    private SDS: SessionDataService,
    private GAS: GoogleAnalyticsService,
    private AAS: AdobeAnalyticsService,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService,
    private AS: AccountService,
    private AddonSubS: AddonSubscriptionService,
    private router: Router,
    private appInitService: ApplicationInitializationService,
    private PU: ParentalUtilsService
  ) {
    this.SS.resetVerification.subscribe((r) => {
      if (r) {
        this.VerificationTemplate = false;
        this.showSubscriptionTemplate = false;
        this.showSuccessTemplate = false;
        this.hiddenHeader = false;
        this.showErrorTemplate = false;
      }
    })
    this.SS.CHeckBOgoSKU.subscribe((r)=>{
      if(r){
        this.bogoAddonsSubsribe = true;
      }
    })
  }

  // ngDestory() {
  //   this.showSubscriptionTemplate = false;
  //   this.showSuccessTemplate = false;
  //   this.hiddenHeader = false;
  //   this.SS.addonBuySuccessfully.unsubscribe();
  // }

  ngOnInit() {
    this.isParentalTarrifCardFlow = this.data?.isParentalTarrifCardFlow;
 
    this.AAS.pageLoadedEvent(this.data.type, 'verify your eligibilty', false);
   
    if (this.data && this.data.roaming) {
      this.onVerification_Roaming(this.data?.planName, 'sendOTP');
    }
    // DBB-4236 Changes  :START
    const isAddToBill = localStorage.getItem('AddToBill');
    if (isAddToBill && isAddToBill == '1') {
      this.isATB = true;
      this.ATBPostpaidAccount = localStorage.getItem('PostpaidAccount');
    }
    
    // DBB-4236 Changes  :END
    this.getUserInfo();
    this.VerificationTemplate = false;
    this.addonType = this.data?.type;
    const w = document?.documentElement?.clientWidth || window?.innerWidth;
    if (w < 992) {
      this.ismobileScreen = true;
    } else {
      this.ismobileScreen = false;
    }
    const locale = this.UTS.getLocaleLanguage().toLocaleLowerCase();
    this.language =
      localStorage.getItem('language') &&
      localStorage.getItem('language').toLocaleLowerCase();
    if (locale == 'ar') {
      this.isArabic = true;
    } else {
      this.isArabic = false;
    }
    this.SS.addonBuySuccessfully.subscribe((r) => {
      if (r && r.success == true) {
        this.showSubscriptionTemplate = false;
        this.showSuccessTemplate = true;
        this.hiddenHeader = true;
        if (
          this.appInitService?.environmentConfig
            ?.ENABLE_ADDONS_SUBSCRIPTION_NEW_FLOW == 'TRUE'
        ) {
          this.modalController.dismiss();
          this.router.navigateByUrl(
            `/success?&lang=${this.UTS.getLocaleLanguage().toLocaleLowerCase()}`
          );
        }
      }
      if (r && r.success == false) {
        this.showArenaProTemplate = false;
        this.showSubscriptionTemplate = false;
        this.showSuccessTemplate = false;
        this.hiddenHeader = true;
        this.showErrorTemplate = true;
      }
    });
    setTimeout(async () => {
      this.sku = this.SKUDS.get();
      const subCategoryId = localStorage.getItem('subCategoryId'); 
      if(this.sku && this.sku?.productType  && this.sku?.productType  == AppSettings.KIDS_ADDONS){
      this.kidsAddon = true;
      }
      else{
      this.kidsAddon = false;
      }
      this.addon = this.SDS.getAddon();
      this.showSubscriptionTemplate = false;
      this.showSuccessTemplate = false;
      this.hiddenHeader = false;
      this.showErrorTemplate = false;
      this.getSKUDetails();
      this.getUserInfo();
      this.SS.sku.subscribe((main) => {
        if (main && main.name) {
          this.addon = main.name;
        }
        if (main && main.value) {
          this.categoryDetail = main.value;
        }
        if (main && main.value && main.value.currentCategory) {
          this.categoryName = main.value.currentCategory;
        }
        this.cdr.detectChanges();
      });
      if(this.isParentalTarrifCardFlow && this.userLoggedIn){
        this.goToAccountSelection();
      }else{
        this.SS.currentAccount.subscribe((r) => {
          if ((r && r.mobileNumber) || (r && r.accountNo)) {
            this.SS.account.next(
              r.mobileNumber ? r.mobileNumber : r.accountNo ? r.accountNo : ''
            );
            // check here
            const num : any = r.mobileNumber ? r.mobileNumber : r.accountNo ? r.accountNo : '';
            if(this.sku?.productType?.toLowerCase() == 'arenagamingaddon' || this.sku?.productType == 'ARENA_GAMING_ADDON'){
              this.showSubscriptionTemplate = false;
              this.showArenaProTemplate = true;
              this.checkAccountType(num,(valid)=>{
                if(valid) {
                 //arena comp
                 setTimeout(()=>{
                  this.showSubscriptionTemplate = false;
                  this.showArenaProTemplate = true;
                  this.cdr.detectChanges();
                 },500);
                }else{
                }
              });
            }else{
                this.showSubscriptionTemplate = true;
              // this.showArenaProTemplate = true;
  
            }
          }
        });
      }
     
      setTimeout(() => {
        this.loadingCompleted = true;
      }, 500);
    }, 500);
  }
  onVerification_Roaming(planName, action) {
    let modal_data = {
      event: 'b2b_fire_event',
      eventCategory: 'roaming',
      eventAction: 'OTP_Verification',
      eventLabel: action,
      typeOfRoaming: planName,
      user_env: this.UTS.getENV(),
    };
  }
  async getAllAccounts(){
    this.AS.getAllAccount().subscribe((res:any) => {
      if(res && res?.userAccounts?.length){
        this.userAccounts = res.userAccounts;
      }
    })
  }

  private getSKUDetails() {
    this.UTS.clearError();
    this.cdr.detectChanges();
    this.SKUDS.getSkuById(
      this.sku && this.sku?.skuId
        ? this.sku?.skuId
        : this.sku && this.sku?.id
        ? this.sku?.id
        : ''
    ).subscribe((r) => {
      let skupromotion, validityType;
      if (this.sku && this.sku?.skuPromotion) {
        skupromotion = JSON.parse(JSON.stringify(this.sku?.skuPromotion));
      }
      if (this.sku && this.sku.validityType) {
        validityType = JSON.parse(JSON.stringify(this.sku?.validityType));
      }
      this.sku = { ...this.sku, ...r };
      this.SKUDS.set(this.sku);
      if (skupromotion) {
        this.sku.skuPromotion = skupromotion;
      }
      if (validityType) {
        this.sku.validityType = validityType;
      }
      if (this.sku && this.sku.isAutoRenewal) {
        const isAutoRenewal = JSON.parse(
          JSON.stringify(this.sku.isAutoRenewal)
        );
        this.sku.isAutoRenewal = isAutoRenewal;
      }
      this.cdr.detectChanges();
      this.SS.skuDetails.next(this.sku);
      this.SS.skuBackendIdDetail.next(this.sku);
    });
  }

  private async skuDetails(id: string) {
    const response = await this.SKUDS.geteShopSKU(id)
      .toPromise()
      .catch((e) => this.UTS.log(e));
    return response;
  }

  private async skuadditional(link: string) {
    const response = await this.SKUDS.getAdditionalSkus(link)
      .toPromise()
      .catch((e) => this.UTS.log(e));
    return response;
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController
      .dismiss({
        dismissed: true,
      })
      .then(() => {
        this.showSubscriptionTemplate = false;
        this.showSuccessTemplate = false;
        this.hiddenHeader = false;
        // this.SS.addonBuySuccessfully.unsubscribe();
        this.UTS.clearError();
        this.cdr.detectChanges();
      });
  }

  getOTP() {
    // if(this.enableResendcode == false){
    //   return false;
    // }
    this.mobileErrorMSG = '';
    this.ngOtpInput.setValue(null);
    this.UTS.clearError();
    this.productService.getMobileEligibility(this.mobileNumber).subscribe(
      (resp) => {
        if (resp.status == 1) {
          this.AAS.addLinkCTAEvent(
            'Send Code',
            'other',
            'eligibility',
            this.data.type,
            'send OTP for Etisalat Number'
          );
          //&& resp.accountId remove account ID for non logged in customer
          this.productService.generateOTP(this.mobileNumber).subscribe(
            (resp) => {
              this.maskedAccountNo = resp.maskedAccountNo;
              this.token = resp?.token;
              this.otpVerificationScreen = true;
              this.GAS.OTPVerification(this.categoryName, 'Verify');
              setTimeout(() => {
                this.resendCodeTimer();
              }, 500);
            },
            (e) => {
              // this.UTS.error(e.error.message);
              this.mobileErrorMSG = e.error.message;
              if (e.error.message == 'NO_ACCOUNT_EMAIL_FOR_ELIFE_NUMBER') {
                let errorTitle = 'Invalid number';
                let errorMessage =
                  'Sorry, this number isn’t registered with etisalat. Please try again with another number.';
                if (this.isArabic) {
                  errorTitle = 'الرقم غير صحيح';
                  errorMessage =
                    'عذرًا، هذا الرقم غير مُسجل لدى إتصالات. يرجى إعادة المحاولة باستخدام رقم آخر';
                }
                this.mobileErrorMSG = `${errorTitle}: ${errorMessage}`;
                this.AAS.pageErrorEvent(
                  this.data.type,
                  'eligibility',
                  'error - Not eligible',
                  '400',
                  false
                );
              }
            }
          );
        } else {
          let errorTitle = 'Invalid number';
          let errorMessage =
            'Sorry, this number isn’t registered with etisalat. Please try again with another number.';
          if (this.isArabic) {
            errorTitle = 'الرقم غير صحيح';
            errorMessage =
              'عذرًا، هذا الرقم غير مُسجل لدى إتصالات. يرجى إعادة المحاولة باستخدام رقم آخر';
          }
          this.mobileErrorMSG = `${errorTitle}: ${errorMessage}`;
          this.AAS.pageErrorEvent(
            this.data.type,
            'eligibility',
            'error - Not eligible',
            '400',
            false
          );
        }
      },
      (e) => {
        this.mobileErrorMSG = e.error.message;
        this.AAS.pageErrorEvent(
          this.data.type,
          'eligibility',
          'error - Not eligible',
          '400',
          false
        );
      }
    );
  }

  onMobileKeyPress($event) {
    this.mobileErrorMSG = '';
    return (
      ($event.charCode != 8 && $event.charCode == 0) ||
      ($event.charCode >= 48 && $event.charCode <= 57)
    );
  }
  resendOTP() {
    if (this.enableResendcode == false) {
      return false;
    }
    this.mobileErrorMSG = '';
    this.ngOtpInput.setValue(null);
    this.showOTPError = false;
    this.UTS.clearError();
    this.AAS.addLinkCTAEvent(
      'resend OTP',
      'other',
      'eligibility',
      this.data.type,
      'resend OTP'
    );
    this.productService.getMobileEligibility(this.mobileNumber).subscribe(
      (resp) => {
        if (resp.status == 1) {
          //&& resp.accountId remove account ID for non logged in customer
          this.productService.generateOTP(this.mobileNumber).subscribe(
            (resp) => {
              this.maskedAccountNo = resp.maskedAccountNo;
              this.token = resp?.token;
              this.otpVerificationScreen = true;
              this.GAS.OTPVerification(this.categoryName, 'Verify');

              setTimeout(() => {
                this.resendCodeTimer();
              }, 500);
            },
            (e) => {
              this.mobileErrorMSG = e.error.message;
            }
          );
        } else {
          let errorTitle = 'Invalid number';
          this.GAS.OTPVerification(this.categoryName, 'error - Not eligible');

          let errorMessage =
            'Sorry, this number isn’t registered with etisalat. Please try again with another number.';
          if (this.isArabic) {
            errorTitle = 'الرقم غير صحيح';
            errorMessage =
              'عذرًا، هذا الرقم غير مُسجل لدى إتصالات. يرجى إعادة المحاولة باستخدام رقم آخر';
          }
          this.mobileErrorMSG = `${errorTitle}: ${errorMessage}`;
        }
      },
      (e) => {
        this.GAS.OTPVerification(this.categoryName, 'error - Not eligible');

        this.mobileErrorMSG = e.error.message;
      }
    );
  }

  changeOTP(otp: string) {
    this.showOTPError = false;
    this.otp = otp;
  }

  validateOtp() {
    this.showOTPError = false;
    if (this.data?.roaming) {
      this.onVerification_Roaming(this.data?.planName, 'verify');
    }
    this.UTS.clearError();
    this.otpValidationModel.accountNo = this.mobileNumber;
    this.otpValidationModel.authValue = this.otp;
    this.otpValidationModel.authType = 'otp';
    this.otpValidationModel.token = this.token;
    this.AAS.addLinkCTAEvent(
      'Verify',
      'other',
      'eligibility',
      this.data?.type,
      'verify OTP for Etisalat Number'
    );
    this.productService.validateOTP(this.otpValidationModel).subscribe(
      async (resp) => {
        this.showOTPError = false;
        //   if(resp.success) this.route.navigate(['/success'])
        if (resp.success) {
          this.SS.account.next(this.mobileNumber);
          this.GAS.onClickVerify(
            'addons_verify_success',
            this.sku?.displayName,
            this.sku?.skuId,
            'loged_in',
            'OTP'
          );
          this.GAS.OTPVerification(
            this.categoryName || this.sku?.displayName,
            'Submit'
          );
          this.AAS.pageLoadedEvent(this.data?.type, this.data?.type, false, {
            otpSuccess: 1,
          });
          //check here
          if (
            this.sku?.productType?.toLowerCase() == 'arenagamingaddon' ||
            this.sku?.productType == 'ARENA_GAMING_ADDON'
          ) {
            this.AddonSubS.checkAccountType(this.mobileNumber, (valid) => {
              if (valid) {
                this.showArenaProTemplate = true;
                this.modalController.dismiss();
                const subCategoryId = localStorage.getItem('CAT');
                this.AddonSubS.redirectionAddonSubscriptionPage(
                  this.sku,
                  this.roaming,
                  subCategoryId ? subCategoryId : null,
                  (this.showArenaProTemplate) ? true : false
                );
              }
            });
          } else {
            if(this.isParentalTarrifCardFlow){
              // show account selection modal
              this.goToAccountSelection();
            }
            else if(this.sku?.type == 'passAddonSku' && this.bogoAddonsSubsribe ==false){
              this.bogoAddons();
            }
            else if (
              this.appInitService?.environmentConfig
                ?.ENABLE_ADDONS_SUBSCRIPTION_NEW_FLOW == 'TRUE'
            ) {
              this.showSubscriptionTemplate = true;
              this.modalController.dismiss();

              const subCategoryId = localStorage.getItem('CAT');
              this.AddonSubS.redirectionAddonSubscriptionPage(
                this.sku,
                this.roaming,
                subCategoryId ? subCategoryId : null,
                (this.showArenaProTemplate) ? true : false
              );
            }
          }
        } else {
          this.translate.get('OTP_INVALID').subscribe((message) => {
            this.showOTPError = true;
            this.OTPErrorMSG = message;
          });
          this.GAS.onClickVerify(
            'addons_verify_fail',
            this.sku?.displayName,
            this.sku?.skuId,
            'loged_in',
            'OTP'
          );
          this.GAS.OTPVerification(
            this.categoryName || this.sku?.displayName,
            'Error-Invalid OTP'
          );
        }
      },
      (e) => {
        this.UTS.error(e.error.message);
      }
    );
  }
  sendBtnEnable() {
    const category = localStorage.getItem('CAT');
    if (this.mobileNumber && this.mobileNumber.length > 0) {
      if (
        category &&
        (category.toLocaleLowerCase() == 'cat550031' ||
          category.toLocaleLowerCase() == 'cat550030' ||
          category.toLocaleLowerCase() == 'cat550029')
      ) {
        if (this.mobileNumber.length > 8 && this.mobileNumber.length < 10) {
          return true;
        } else {
          return false;
        }
      } else if (
        this.mobileNumber.length > 8 &&
        this.mobileNumber.length < 11
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  resendCodeTimer() {
    // Set the date we're counting down to
    const d = new Date();
    //'Nov 18, 2021 11:29:00'
    const timer =
      d.getFullYear() +
      '-' +
      Number(Number(d.getUTCMonth()) + 1) +
      '-' +
      d.getDate() +
      ' ' +
      d.getHours() +
      ':' +
      (d.getMinutes() + 2) +
      ':' +
      d.getSeconds();
    let countDownDate = new Date(timer.replace(/-/g, '/')).getTime();
    // Update the count down every 1 second

    this.enableResendcode = false;
    let x = setInterval(() => {
      // Get today's date and time
      let now = new Date().getTime();

      // Find the distance between now and the count down date
      let distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      let days: any = Math.floor(distance / (1000 * 60 * 60 * 24));
      days = days < 10 ? '0' + days : days;
      let hours: any = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      hours = hours < 10 ? '0' + hours : hours;
      let minutes: any = Math.floor(
        (distance % (1000 * 60 * 60)) / (1000 * 60)
      );
      minutes = minutes < 10 ? '0' + Number(minutes) : Number(minutes);

      let seconds: any = Math.floor((distance % (1000 * 60)) / 1000);
      seconds = seconds < 10 ? '0' + Number(seconds) : Number(seconds);
      // Output the result in an element with id="demo"
      //days + ':' + hours + ':' +
      const timer = minutes + ':' + seconds + '';
      if (
        document.getElementById('reSendOtpTimer') &&
        document.getElementById('reSendOtpTimerInSeconds')
      ) {
        document.getElementById('reSendOtpTimer').innerHTML =
          minutes + ':' + seconds + '';
        document.getElementById('reSendOtpTimerInSeconds').innerHTML =
          Number(minutes * 60) + Number(seconds) + '';
        if (document.getElementById('reSendOtpTimer2') && seconds >= 0) {
          document.getElementById('reSendOtpTimer2').innerHTML =
            minutes + ':' + seconds + '';
        }
        this.cdr.detectChanges();
      } else {
        clearInterval(x);
      }

      // If the count down is over, write some text
      if (distance < 0) {
        clearInterval(x);
        this.enableResendcode = true;
      }
    }, 1000);
  }


  getUserInfo() {
    this.AS.UserInfo().subscribe(
      (r: any) => {
        if (r && r.userNationality) {
          this.userData = r;
          this.userLoggedIn = true;
          if (localStorage.getItem('currentAccount')) {
            const current_user = JSON.parse(
              localStorage.getItem('currentAccount')
            );
          this.SS.currentAccount.next(current_user);
          }
            this.showSubscriptionTemplate = true;
            this.showSuccessTemplate = false;
        }
        else{
          if(this.data?.isBogoFlow){
            this.showSubscriptionTemplate = true;
          }else{
            this.showSubscriptionTemplate = false;
            this.showSuccessTemplate = false;
          }

        }
      },
      () => {
        if(this.data?.isBogoFlow){
          this.showSubscriptionTemplate = true;
        }else{
          this.showSubscriptionTemplate = false;
          this.userLoggedIn = false;
  
        }
       }
    );
  }
  gotoSubscribeAddon(e) {
    const currentUser =
      JSON.parse(localStorage.getItem('currentAccount')) || null;
    if (
      this.sku &&
      this.sku?.productType &&
      this.sku?.productType == AppSettings.KIDS_ADDONS
    ) {
      if (
        this.userData &&
        this.userData?.loginType &&
        this.userData?.loginType != '1'
      ) {
        this.UTS.error(this.translate.instant('ERROR_KIDS_ADDONS'));
        return;
      } else if (
        this.userData &&
        this.userData?.loginType &&
        this.userData?.loginType == '1' &&
        currentUser &&
        currentUser?.primary
      ) {
        this.UTS.error(
          this.translate.instant('ERROR_KIDS_ADDONS_PRIMARY_ONLY')
        );
      } else {
        this.kidsAddon = false;
      }
    } else {
      this.kidsAddon = false;
    }
    this.cdr.detectChanges();
  }

  checkAccountType(type: any, valid) {
    this.productService.getAccountType(type).subscribe((res: any) => {
      if (res && (res?.accountType?.toLowerCase() == 'prepaid' || res?.accountType?.toLowerCase() == 'postpaid')) {
        return valid(true)
      } else {
        return valid(false);
      }
    }, err => {
      return valid(false);
    })
  }
  


	bogoAddons(){
		let link = '/addAddons';
		let basketAddons = this.createBasketAddons();
		if(this.sku && this.sku?.type == 'passAddonSku'){
			const buyAddonRequest = {
				"accountNo":this.mobileNumber ? this.mobileNumber : this.numberlogin,
				"validate": basketAddons?.length == 1 || true,
				"type": "ONE_TIME",
				"quantity": 1,
				"locale":this.UTS.getLocaleLanguage(),
				"basketAddons": basketAddons,
				"mode":'caramel',
				'gamingAddon': false,
				"addonId": this.sku.skuId
			};
			this.SKUDS.addAddons(buyAddonRequest, link).subscribe((response: any) => {
				if(response && response?.bogoSkus && response?.bogoSkus?.length > 0){
				sessionStorage.setItem("BOGOs", JSON.stringify(response?.bogoSkus));
				this.openBottomSheet(BogoOfferPopupComponent, null, 'verification-modal eand-partail-height-screen-bottom-70-mobile');
				}else{
				this.showSubscriptionTemplate = true;
				}
			},(e) => {
				this.showSubscriptionTemplate = true;
			})
			return;
		}
	}
	createBasketAddons(): any{
	let basketAddons = [];
	basketAddons.push({'addonId':this.sku?.skuId});
	return basketAddons;
	}
	async openBottomSheet(component: any, data,classes = 'verification-modal modal-fullscreen' ) {
	const modal = await this.modalController.create({
		component: component,
		showBackdrop: true,
		componentProps: { data: data },
		// mode: "ios",
		cssClass: classes,
	});
	modal.onDidDismiss().then((x: any) => {
		if(x?.data?.proceedNow){
		this.showSubscriptionTemplate = true;
		this.cdr.detectChanges();
		}
	})
	return await modal.present();
	}
  goToAccountSelection(){
    if(this.userLoggedIn){
      this.modalController.dismiss();
      this.AS.getAllAccount().subscribe((res:any) => {
        if(res && res?.userAccounts?.length){
          this.userAccounts = res.userAccounts;
          if(this.userAccounts.length > 1)
            this.openBottomSheet(AccountSelectionModalComponent, this.userAccounts, 'ion-modal-uplift eand-partail-height-screen-bottom-50 eand-partail-height-screen-bottom-50-mobile');
          else{
            this.navigateToAddonDetail(this.userAccounts[0]?.accountType);
          }
        }
      })
    }else{
      this.productService.getAccountType(this.mobileNumber).subscribe((res:any)=>{
        if(res && (res?.accountType?.toLowerCase() == 'prepaid' || res?.accountType?.toLowerCase() == 'postpaid')){
          if(this.appInitService.environmentConfig.ENABLE_ADDONS_SUBSCRIPTION_NEW_FLOW === 'TRUE'){
            this.modalController.dismiss();
            // redirect to addons new subscription flow 
          }else{
            this.showSubscriptionTemplate = true;
          }
        }
      },err=>{
      })
     
    }
  }
  navigateToAddonDetail(accountType:any){
	let sku = this.PU.getRelatedAddon(accountType);
	if(sku)
		this.router.navigateByUrl(this.PU.navigateAddonDetailUrl(sku));
  }


}
